module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.28"},{"quantity":0.03,"color":"#91E3AD","label":"0.28 - 0.92"},{"quantity":0.06,"color":"#DEFFB0","label":"0.92 - 1.58"},{"quantity":0.1,"color":"#FFE68C","label":"1.58 - 2.53"},{"quantity":9,"color":"#FF9982","label":"2.53 - 3.96"},{"quantity":12,"color":"#FF4D30","label":"3.96 - 14.56"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_90_wheat.json
// module id = LT/X
// module chunks = 171